export const decodeBase64 = (str: string): string => {
    const binaryString = atob(str)
    const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0))

    return new TextDecoder('utf-8').decode(bytes)
}
